import { html } from 'lit-html';
import { LenCountAction } from '../actions/lencount_action';

// TODO Formのバリエーション方針でリファクタリング： https://confluence.askul.co.jp/pages/viewpage.action?pageId=822414189
export const makerNameLenCount = () => html`
  <div class="a-textinput js-input" id="makername_wrapper">
    <span class="a-textinput_inputwrap">
      <input
        type="text"
        class="a-textinput_input clear"
        placeholder="例：セキレイ"
        name="makername"
        id="makername"
        maxlength="30"
        @keyup="${(event: Event) => LenCountAction.LenCount(event)}"
      />
    </span>
  </div>
`;

export const productNameLenCount = () => html`
  <div class="a-textinput js-input" id="productname_wrapper">
    <span class="a-textinput_inputwrap">
      <input
        type="text"
        class="a-textinput_input clear"
        placeholder="例：貼ってはがせるオフィスのふせん"
        name="productname"
        id="productname"
        maxlength="35"
        @keyup="${(event: Event) => LenCountAction.LenCount(event)}"
      />
    </span>
  </div>
`;

export const makerModelLenCount = () => html`
  <div class="a-textinput js-input" id="makermodel_wrapper">
    <span class="a-textinput_inputwrap">
      <input
        type="text"
        class="a-textinput_input clear"
        placeholder="例：G-987657890000"
        name="makermodel"
        id="makermodel"
        maxlength="20"
        @keyup="${(event: Event) => LenCountAction.LenCount(event)}"
      />
    </span>
  </div>
`;

export const jancodeLenCount = () => html`
  <input
    type="text"
    class="a-textinput_input clear"
    placeholder="例：2877706"
    name="jancode"
    id="jancode"
    maxlength="13"
    @keyup="${(event: Event) => LenCountAction.LenCount(event)}"
  />
`;

export const commentLenCount = () => html`
  <textarea
    name="comment"
    class="clear"
    id="comment"
    rows="6"
    maxlength="200"
    @keyup="${(event: Event) => LenCountAction.LenCount(event)}"
  ></textarea>
`;
